module.exports = __webpack_public_path__ + "img/albe.4c7ff0d1.png";